import { HouseAdSizeBean, HouseAdSizeControllerApi, ItemResponseHouseAdSizeBeanObject, ListResponseHouseAdSizeBean } from 'src/api/api';
import { BaseApi, configuration } from '../../../api/BaseApi';
import { processError } from '../../../api/customFetch';

class HouseAdSizeApi extends BaseApi {
    api: HouseAdSizeControllerApi;

    constructor() {
        super();
        this.api = new HouseAdSizeControllerApi(configuration, configuration.basePath, this.customFetch);
    }

    list(size: number = 20, page: number = 1, search?): Promise<ListResponseHouseAdSizeBean> {
        return this.api.adSizeList(search, {query: {size, page: page}}).then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    all(): Promise<ListResponseHouseAdSizeBean> {
        return this.api.adSizeList().then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    create(HouseAdSize: HouseAdSizeBean): Promise<ItemResponseHouseAdSizeBeanObject> {
        return this.api.createAdSize(HouseAdSize).then(created => {
            return Promise.resolve(created);
        }).catch(err => {
            return processError(err);
        });
    }

    edit(id: number, HouseAdSize: HouseAdSizeBean): Promise<ItemResponseHouseAdSizeBeanObject> {
        return this.api.editAdSize(HouseAdSize, id).then(updated => {
            return Promise.resolve(updated);
        }).catch(err => {
            return processError(err);
        });
    }

    view(id: number): Promise<ItemResponseHouseAdSizeBeanObject> {
        return this.api.adSize(id).then(HouseAdSize => {
            return Promise.resolve(HouseAdSize);
        }).catch(err => {
            return processError(err);
        });
    }

    delete(id: number): Promise<void> {
        return this.api.deleteAdSize(id).then(() => {
            return Promise.resolve();
        }).catch(err => {
            return processError(err);
        });
    }
}

const houseAdSizeApi = new HouseAdSizeApi();

export default houseAdSizeApi;
